/**
 * CreateUserButton Component
 *
 * This component renders a button to create a new user.
 * It checks the session permissions to determine if the current user
 * has the ability to create a new user. If not, it returns `null` and does not render the button.
 *
 * @param {Props} props - Component props.
 * @param {boolean} props.showForm - Whether the user creation form is visible.
 * @param {React.Dispatch<React.SetStateAction<boolean>>} props.setShowForm - Function to toggle the form visibility.
 *
 * @returns {JSX.Element | null} The "Create Member" button if the user has permissions, otherwise `null`.
 */
import React from "react"
import Cookies from "js-cookie"
import { container } from "../../infrastructure/container"
import { SessionService } from "../../infrastructure/services/session"
import { FranchiseService } from "../../infrastructure/services/api/franchise"

interface LogoutProps {
  className?: string
  style?: React.CSSProperties
}

const LogoutButton: React.FC<LogoutProps> = ({ className, style }) => {
  const sessionService = container.resolve<SessionService>("sessionService")
  const franchiseService = container.resolve<FranchiseService>("franchiseService")

  const handleLogout = async () => {
    const allCookies = Cookies.get()

    Object.keys(allCookies).forEach((cookie) => {
      Cookies.remove(cookie, { path: "/", domain: "localhost" })
    })

    await franchiseService.logout()
    sessionService.resetStorage()

    window.location.href = "/login"
  }

  return (
    <button onClick={handleLogout} className={className} style={style}>
      Logout
    </button>
  )
}

export default LogoutButton